import { Box } from '@mui/material'
import React from 'react'
import MapComponent from './MapComponent'

const Map = () => {
  return (
    <Box sx={{height: '100vh'}}>
        <MapComponent />
    </Box>
  )
}

export default Map